export * from './ubiSidebar.component';



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/components/ubiSidebar/index.ts